import { useCallback } from 'react';
import {
  CategoryID,
  CategoryLocalizedName
} from '../../../../../../categories/categoriesTypes';

import { useReactQueryState } from '../../../../../../common/reactQuery/hooks/useReactQueryState';

import { StockCache } from '../../../../../StockCache';

function useThreeDStockLifestylesContentCheckedCategories() {
  const { value: checkedCategories, setValue: setCheckedCategories } =
    useReactQueryState<
      { id: CategoryID; localizedName: CategoryLocalizedName }[]
    >(StockCache.checkedLifestylesCategories(), []);

  const clearCheckedCategories = useCallback<() => void>(() => {
    setCheckedCategories([]);
  }, [setCheckedCategories]);

  return {
    checkedCategories,
    setCheckedCategories,
    clearCheckedCategories
  };
}

export default useThreeDStockLifestylesContentCheckedCategories;
